export default __webpack_public_path__ + "static/media/closet4-768w.ba67cfe6.avif";